import React from "react";
import { Text } from "./styled";

const Label = ({ text }) => {
  return <Text>{text}</Text>;
};

export default Label;
